export default __webpack_public_path__ + "static/media/Spectral-Light.cf0847d6.ttf";